

export function isValidDeliveryPostalCode(address) {
    if(address.country === 'FR') {
        return !address.postal_code?.match(/^(97|98)/);
    }
    return true;
}
